import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import { setLenis } from "@/lib/scroll";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { MenuShowcase } from "@/components/site/MenuShowcase";
import { Manifesto } from "@/components/site/Manifesto";
import { EnquiryForm } from "@/components/site/EnquiryForm";
import { Footer } from "@/components/site/Footer";
import { Catalogue } from "@/components/site/Catalogue";

// Smooth-scroll setup lives inside the router so location is accessible
function AppInner() {
  const location = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(lenis);
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      setLenis(null);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain font-body bg-[#FDFBF7] text-[#2A221C] antialiased">
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <main>
              <Hero />
              <Marquee />
              <MenuShowcase />
              <Manifesto />
              <EnquiryForm />
            </main>
          }
        />
        <Route path="/catalogue" element={<Catalogue />} />
      </Routes>
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppInner />
    </BrowserRouter>
  );
}

export default App;
